export const getNotifications = (state: any) => {
    const { notifications } = state;

    return notifications.notifications;
};
